/*!
 * concat.managers.Bookmarks
 * 
 * version: 1.0.0
 * author: John Bandy, john@concatsys.com
 * company: Concat Systems, Inc.
 * git: https://github.com/ConcatSystems/SharedLibs
 *
 * requirements:
 *   - jQuery ($ or concat.$)
 *
 * ©2019 Concat Systems, Inc.
 */


( ( window, undefined ) => {

  // set up namespace
  window.concat = window.concat || {};
  window.concat.managers = window.concat.managers || {};


  // helper object
  function BookmarkData( id, time, label, icon )
    {
      this.id    = id || "";
      this.time  = !isNaN( parseFloat( time ) )
                 ? parseFloat( time )
                 : -1;
      this.label = label || "";
      this.icon  = icon || "";
    }
  BookmarkData.prototype.toString = function() {
    return `[object BookmarkData id:${this.id} time:${this.time} label:${this.label.substr(0,10)}]`
  }


  // Singleton
  window.concat.managers.Bookmarks = ( function() {

      var _items          = [];

      /**
       * _insertItemByTime
       *
       * @param {item} a BookmarkData object
       * @param {min} the minimum index of the subset array
       * @param {max} the maximum index of the subset array
       */
      //------------------------------------------------------------------------
      var _insertItemByTime = function( item, min, max ) {

          // concat.utils.Log( "Bookmarks :: _insertItemByTime(), min:", min, "max:", max );

          // if the array is empty, or if items are already sorted from the 
          // input, let's do this check for a best-case complexity of O(1)
          // for insertion into the list...
          if( max === -1 || ( max === _items.length - 1 && item.time > _items[max].time ) )
          {            
            _items.push( item );
            return;
          }
          if( min === 0 && item.time < _items[min].time )
          {
            _items.unshift( item );
            return;
          }

          var mid = min + Math.floor( ( max - min ) / 2 );

          // otherwise, do a recursive binanry search for the insertion point 
          // for a worst-case complexity of O(log n)

          // is the current `time` between those at items at `mid` and `mid+1`?
          if( item.time > _items[mid].time && 
              item.time <= _items[mid+1].time )
          {
            // concat.utils.Log( "    inserting at mid+1..." );
            _items.splice( mid+1, 0, item );
            return;
          }

          // no? try searching the next appropriate 'half' of the array
          else if( item.time <= _items[mid].time )
          {
            _insertItemByTime( item, min, mid )
            return;
          }

          else if( item.time > _items[mid+1].time )
          {
            _insertItemByTime( item, mid+1, max );
            return;
          }
        }

      //------------------------------------------------------------------------
      return {

        hasItems : function() {
            return( _items.length > 0 )
          },

        /**
         * items
         *
         * @param {id} track identifier 
         *
         * @returns {object} 
         */
        //----------------------------------------------------------------------
        items : function() {
            return _items;
          },

        /**
         * init
         *
         * @param {list} array of bookmarks
         *
         * @returns {Promise} 
         */
        //----------------------------------------------------------------------
        addList : function( list ) {
            // concat.utils.Log( "Bookmarks :: addList(), list.length:", list.length );

            var p = new Promise( function( resolve, reject ) {

                // validate `list` is an array
                if( !Array.isArray( list ) )
                  { reject( new Error( "Bookmarks :: addList(), Error: `list` is not an array." ) ); return; }

                for( var i = 0; i < list.length; i++ )
                {
                  // defaults & validation

                  var b   = list[i];
                  var bd  = new BookmarkData( b.id, b.time, b.label, b.icon );
                  // console.log( "  i:", i, "bd", bd.toString() );
                  // console.log( "    test:", ( bd.time === -1 || ( bd.icon === "" && bd.label === "" ) ) );

                  if( bd.id === "" || bd.time === -1 || ( bd.icon === "" && bd.label === "" ) )
                    continue;

                  // console.log( "    inserting..." );

                  // `bd` passed the test, add it to the items list.
                  // _items.push( bd );
                  _insertItemByTime( bd, 0, _items.length-1 );

                  // console.log( "  i(",i,") - AFTER INSERTION, _items:", _items );
                }

                // no valid items in list?
                if( !_items.length )
                  { reject( new Error( "Bookmarks :: addList(), Error: `list` contained no valid bookmark items." ) ); return; }

                // all good!
                resolve();
              });

            return( p );
          }

      } // return {...}
    })();

})( window );